import { styles } from './template.scss';
import { FontSizes, FontWeights } from '../../../../../types/common/types';

export const templateSubmitToSandboxSettingsForm = document.createElement('template');

templateSubmitToSandboxSettingsForm.innerHTML = `
  <style>${styles}</style>
  <div class="wrapper">
    <gz-title id="title" fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}'></gz-title>
    <gz-text id="description" fontSize='${FontSizes.PARAGRAPH_12}'></gz-text>
    <gz-input-text-grid id="input-grid"></gz-input-text-grid>
  </div>
`;
